import check from "./check.svg";

export default function CheckIcon({ width, height }) {
  return (
    <img src={check} width={width} height={height} />
  );
}